import { inject } from "@angular/core";
import { CanActivateFn, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { UserProfileGuardService } from "@vp/user-profile/feature";

export const UserProfileGuard: CanActivateFn = ():
  | boolean
  | UrlTree
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree> => {
  return inject(UserProfileGuardService).canActivate();
};
